import Model from './Model'
import Notice from './Notice'
import Member from './Member'
import GroupSession from './GroupSession'
import Post from './Post'
import Comment from '@/models/Comment'

export default class Group extends Model {
  resource() {
    return 'groups'
  }

  users() {
    return this.hasMany(Member)
  }

  notices() {
    return this.hasMany(Notice)
  }

  sessions() {
    return this.hasMany(GroupSession)
  }

  posts() {
    return this.hasMany(Post)
  }

  comments() {
    return this.hasMany(Comment)
  }
}
